<script>
    import moment from 'moment';

    export default {
        name: "Util",
        install: function (Vue, name = '$util') {
            Object.defineProperty(Vue.prototype, name, {value: this});
        },
        format_date: function (data, formato) {
            return moment(data).format(formato)
        }

    }
</script>